<div class="color-bar"></div>
<div class="conteudo ml-2 mr-2">
  <app-loading [exibir]="carregando"></app-loading>
  <div *ngIf="!carregando">
    <div class="mt-3">
      <div class="row">
        <div class="col">
          <h5 class=" ml-2" translate>
            AfterSales Dashboard
          </h5>
        </div>
        <div class="col">
          <button class="btn btn-outline-secondary btn-sm mb-2 ml-2 float-right" (click)="exportarExcel()">
            <em class="fa fa-download fa-xs"></em>
            Export Excel
          </button>
        </div>
      </div>
    </div>
    <div class="content">
      <p-table #dt dataKey="id" [value]="tempDados.dados" selectionMode="single" styleClass="p-datatable-responsive-demo
            p-datatable-striped
            p-datatable-sm" [columns]="selectedColumns" [columns]="cols" [value]="rows" [autoLayout]="true"
        id="excel-table" class="style">
        <ng-template pTemplate="caption">
          <div class="table-header">
            <span class="p-input-icon-left mr-1">
              <i class="pi pi-search"></i>
              <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                placeholder="{{'relatorioVeiculos.veiculoVendido.filtroGeral' | translate}}" />
            </span>
            <p-multiSelect *ngIf="this.translate.currentLang == 'br'" (click)="ocultaFooter()" [options]="cols"
              [(ngModel)]="selectedColumns" optionLabel="headerBr"
              selectedItemsLabel="{{'businessIntelligence.dashboard.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'businessIntelligence.dashboard.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
            <p-multiSelect *ngIf="this.translate.currentLang == 'gb'" (click)="ocultaFooter()" [options]="cols"
              [(ngModel)]="selectedColumns" optionLabel="headerGb"
              selectedItemsLabel="{{'businessIntelligence.dashboard.colunasSelecionadas' | translate}}"
              [style]="{minWidth: '200px'}"
              placeholder="{{'businessIntelligence.dashboard.colunasSelecionadasPlaceHolder' | translate}}">
            </p-multiSelect>
          </div>
        </ng-template>
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th [translate]="getTranslate(col.header)" [ngStyle]="{'width': col.width}" class="text-center percentual" [pSortableColumn]="col.field"
              *ngFor="let col of columns">
              {{col.header}}
              <img class="mb-1" width="10" height="10" src="assets/img/imgIconSort.svg" alt="Logo" />
            </th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-dados let-columns="columns">
          <tr>
            <td class="text-center percentual" *ngFor="let col of columns">
              <div [ngClass]="{'text-center': col.field !== 'codigo_dealer'}">
                {{col.type ? col.type.transform(dados[col.field], col.arg1, col.arg2, col.arg3) :
                                dados[col.field]}}
              </div>
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="footer">
          <tr class="tr-footer">
            <td [hidden]="!ocultaCodigoDealer">
              {{codigo_dealer}}
            </td>
            <td [hidden]="!ocultaNomeDealer" [translate]="getTranslate(nome_dealer)">
              <!-- {{nome_dealer}} -->
            </td>
            <td [hidden]="!ocultaRegistro">
              {{registro_servico | percent: '1.0-0'}}
            </td>
            <td [hidden]="!ocultaRetencao">
              {{retencao | percent: '1.0-0'}}
            </td>
            <td [hidden]="!ocultaPecasBudget">
              {{pecas_budget | currency: ' '}}
            </td>
            <td [hidden]="!ocultaRoupasBudget">
              {{roupas_budget | currency: ' '}}
            </td>
            <td [hidden]="!ocultaAcessoriosBudget">
              {{acessorios_budget | currency: ' '}}
            </td>
            <td [hidden]="!ocultaSpuie">
              {{spuie | currency: ' '}}
            </td>
            <td [hidden]="!ocultaSpuio">
              {{spuio | currency: ' '}}
            </td>
            <td [hidden]="!ocultaCspuio">
              {{cspuio | currency: ' '}}
            </td>
            <td [hidden]="!ocultaAspuio">
              {{aspuio | currency: ' '}}
            </td>
            <td [hidden]="!ocultaEstoqueAMP">
              {{this.estoque_amp | percent: '1.0-0'}}
            </td>
            <td [hidden]="!ocultaPCAObsoletos">
              {{pca_obsoletos | percent: '1.0-0'}}
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>
